import { render, staticRenderFns } from "./income-approve.vue?vue&type=template&id=e0dda6c0&scoped=true&"
import script from "./income-approve.vue?vue&type=script&lang=js&"
export * from "./income-approve.vue?vue&type=script&lang=js&"
import style0 from "./income-approve.vue?vue&type=style&index=0&id=e0dda6c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dda6c0",
  null
  
)

export default component.exports